import { render, staticRenderFns } from "./big-commerce-pair-organization.vue?vue&type=template&id=7e37bd67&scoped=true&"
import script from "./big-commerce-pair-organization.vue?vue&type=script&lang=js&"
export * from "./big-commerce-pair-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e37bd67",
  null
  
)

export default component.exports